import { useCallback, useEffect, useRef, useState } from 'react';
import { createSelector } from 'reselect';
import { Button, Form, Input /* , UncontrolledTooltip */ } from 'reactstrap';
/* import { Link } from 'react-router-dom'; */
// hooks
import { useRedux } from '../../../hooks/index';
import useDebounce from '../../../hooks/useDebounce';

// actions
import {
    /* createContact,
    resetContacts,
    getFavourites, */
    getDirectMessages,
    /* getChannels, */
    /* addContacts, */
    /* createChannel, */
    changeSelectedChat,
    getChatUserDetails,
    updateCurrentPageDirectMessages,
    updateSearchChat,
    getChatUserMessages,
    /* getChannelDetails,
    getArchiveContact,*/
    readConversation,
    updateCurrentPageUserMessages
} from '../../../redux/actions';

// interfaces
/* import { CreateChannelPostData } from '../../../redux/actions'; */

// components
import AppSimpleBar from '../../../components/AppSimpleBar';
/* import AddGroupModal from '../../../components/AddGroupModal';
import CreateContactModal from '../../../components/CreateContactModal';
import AddButton from '../../../components/AddButton';
import ContactModal from '../../../components/ContactModal'; */

/* import Favourites from './Favourites'; */
import DirectMessages from './DirectMessages';
/* import Chanels from './Chanels'; */
/* import Archive from './Archive'; */
import { CHATS_TABS } from '../../../constants';
import config from '../../../config';

interface IndexProps {}
const Index = (props: IndexProps) => {
    // global store
    const { dispatch, useAppSelector } = useRedux();

    const errorData = createSelector(
        (state: any) => state.Contacts,
        (props: any) => props.Chats,
        (loginState: any) => loginState.Login,
        (layoutState: any) => layoutState.Layout,
        (state, props, loginState, layoutState) => ({
            /* isContactInvited: state.isContactInvited,
            favourites: props.favourites, */
            directMessages: props.directMessages,
            /* channels: props.channels, */
            isContactsAdded: props.isContactsAdded,
            /* isChannelCreated: props.isChannelCreated, */
            selectedChat: props.selectedChat,
            /* isFavouriteContactToggled: props.isFavouriteContactToggled,
            archiveContacts: props.archiveContacts,
            isContactArchiveToggled: props.isContactArchiveToggled,
            chatUserDetails: props.chatUserDetails */
            selectedInstance: props.selectedInstance,
            getDirectMessagesLoading: props.getDirectMessagesLoading,
            hasMoreDirectMessages: props.hasMoreDirectMessages,
            currentPageDirectMessages: props.currentPageDirectMessages,
            searchChat: props.searchChat,
            activeTab: layoutState.activeTab
        })
    );

    // Inside your component
    const {
        /* isContactInvited,
        favourites, */
        directMessages,
        /* channels, */
        /* isContactsAdded, */
        /* isChannelCreated, */
        selectedChat,
        /* isFavouriteContactToggled,
        archiveContacts,
        isContactArchiveToggled,
        chatUserDetails */
        selectedInstance,
        getDirectMessagesLoading,
        hasMoreDirectMessages,
        currentPageDirectMessages,
        searchChat,
        activeTab
    } = useAppSelector(errorData);

    // get data
    /* useEffect(() => {
        if (isFavouriteContactToggled) {
            dispatch(getFavourites());
            dispatch(getDirectMessages());
        }
    }, [dispatch, isFavouriteContactToggled]); */

    /* invite contact modal handeling */
    /* const [isOpen, setIsOpen] = useState<boolean>(false);
    const openModal = () => {
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    }; */

    /* onCreate handeling */
    /* const onCreateContact = (data: any) => {
        dispatch(createContact(data));
        closeModal();
    };
    useEffect(() => {
        if (isContactInvited) {
            setIsOpen(false);
            setTimeout(() => {
                dispatch(resetContacts('isContactInvited', false));
            }, 1000);
        }
    }, [dispatch, isContactInvited]); */

    /* contact add handeling */
    /* const [isOpenAddContact, setIsOpenAddContact] = useState<boolean>(false);
    const openAddContactModal = () => {
        setIsOpenAddContact(true);
    };
    const closeAddContactModal = () => {
        setIsOpenAddContact(false);
    };
    const onAddContact = (contacts: Array<string | number>) => {
        dispatch(addContacts(contacts));
    };
    useEffect(() => {
        if (isContactsAdded) {
            setIsOpenAddContact(false);
            dispatch(getDirectMessages(selectedInstance));
        }
    }, [dispatch, isContactsAdded, selectedInstance]); */

    /* channel creation handeling */
    /* const [isOpenCreateChannel, setIsOpenCreateChannel] =
        useState<boolean>(false);
    const openCreateChannelModal = () => {
        setIsOpenCreateChannel(true);
    };
    const closeCreateChannelModal = () => {
        setIsOpenCreateChannel(false);
    };
    const onCreateChannel = (channelData: CreateChannelPostData) => {
        dispatch(createChannel(channelData));
    };
    useEffect(() => {
        if (isChannelCreated) {
            setIsOpenCreateChannel(false);
            dispatch(getChannels());
        }
    }, [dispatch, isChannelCreated]);  */

    /*
  select chat handeling :
    get conversations
    get chat user details
  */

    const onSelectChat = (
        personId: number | string,
        conversationId: string
        /* , isChannel?: boolean */
    ) => {
        /* if (isChannel) {
            dispatch(getChannelDetails(id));
        } else {
            dispatch(getChatUserDetails(id));
        } */
        dispatch(getChatUserDetails(personId));
        dispatch(readConversation(conversationId));
        dispatch(
            getChatUserMessages(conversationId, {
                page: 1
            })
        );
        dispatch(updateCurrentPageUserMessages(1));
        dispatch(changeSelectedChat({ personId, conversationId }));
    };

    /* tab handeling */
    const [active /* , setActive */] = useState(CHATS_TABS.DEFAULT);
    /* const onChangeTab = (tab: CHATS_TABS) => {
        setActive(tab);
    }; */

    /* archive contacts */
    /* useEffect(() => {
        dispatch(getArchiveContact());
    }, [dispatch]);
    useEffect(() => {
        if (isContactArchiveToggled) {
            dispatch(getArchiveContact());
            dispatch(getFavourites());
            dispatch(getDirectMessages());
            dispatch(getChannels());
            dispatch(getChatUserDetails(chatUserDetails.id));
        }
    }, [dispatch, isContactArchiveToggled, chatUserDetails.id]); */

    const ref = useRef<any>();
    const scrollRef = useRef<any>();
    //search recent user
    const [search, setSearch] = useState('');
    const debouncedSearch = useDebounce(search);

    const intersectionObserver = useRef<IntersectionObserver | null>(null);
    const lastChatElementRef = useCallback(
        (chat: any) => {
            if (getDirectMessagesLoading) return;
            if (intersectionObserver.current)
                intersectionObserver.current.disconnect();
            intersectionObserver.current = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting && hasMoreDirectMessages) {
                        dispatch(
                            updateCurrentPageDirectMessages(
                                currentPageDirectMessages + 1
                            )
                        );
                    }
                }
            );
            if (chat) intersectionObserver.current.observe(chat);
        },
        [
            getDirectMessagesLoading,
            hasMoreDirectMessages,
            currentPageDirectMessages,
            dispatch
        ]
    );

    const onChangeSearch = (value: string) => {
        setSearch(value);
    };

    useEffect(() => {
        const fetchChats = (page?: number, chunkSizeFactor?: number) => {
            /* dispatch(getFavourites()); */
            /* dispatch(getChannels()); */
            dispatch(
                getDirectMessages({
                    instance: selectedInstance,
                    search: searchChat,
                    page: page ?? currentPageDirectMessages,
                    chunkSizeFactor: chunkSizeFactor
                })
            );
        };
        let interval: any;
        if (activeTab === 'pills-chat') {
            interval = setInterval(() => {
                scrollRef.current = ref.current.getScrollElement().scrollTop;
                currentPageDirectMessages === 1
                    ? fetchChats(1)
                    : fetchChats(1, currentPageDirectMessages);
            }, config.SET_INTERVAL_TIME);
        } else {
            clearInterval(interval);
        }

        fetchChats();
        return () => clearInterval(interval);
    }, [
        searchChat,
        currentPageDirectMessages,
        dispatch,
        selectedInstance,
        activeTab
    ]);

    useEffect(() => {
        dispatch(updateSearchChat(debouncedSearch));
    }, [debouncedSearch, dispatch]);

    useEffect(() => {
        ref.current.getScrollElement().scrollTo({ top: scrollRef.current });
    }, [directMessages]);

    return (
        <>
            <div>
                <div className="px-4 pt-4">
                    <div className="d-flex align-items-start">
                        <div className="flex-grow-1">
                            <h4 className="mb-4">Chats</h4>
                        </div>
                        {/* <div className="flex-shrink-0">
                            <div id="add-contact">
                                <AddButton onClick={openModal} />
                            </div>
                            <UncontrolledTooltip
                                target="add-contact"
                                placement="bottom"
                            >
                                Add Contact
                            </UncontrolledTooltip>
                        </div> */}
                    </div>
                    <Form>
                        <div className="input-group mb-3">
                            <Input
                                id="serachChatUser"
                                type="text"
                                className="form-control bg-light border-0 pe-0"
                                placeholder="Search Contact"
                                onChange={(e) => {
                                    onChangeSearch(e.target.value);
                                }}
                            />
                            <Button
                                color="light"
                                type="button"
                                id="searchbtn-addon"
                            >
                                <i className="bx bx-search align-middle"></i>
                            </Button>
                        </div>
                    </Form>
                </div>{' '}
                {/* .p-4 */}
                <AppSimpleBar className="chat-room-list" scrollRef={ref}>
                    {/* Start chat-message-list */}
                    {active === CHATS_TABS.DEFAULT && (
                        <>
                            {/* favourite */}
                            {/* <Favourites
                                users={favourites}
                                selectedPersonChat={selectedChat.personId}
                                onSelectChat={onSelectChat}
                            /> */}

                            {/* direct messages */}
                            <DirectMessages
                                users={directMessages}
                                /* openAddContact={openAddContactModal} */
                                selectedPersonChat={selectedChat?.personId}
                                onSelectChat={onSelectChat}
                                ref={lastChatElementRef}
                            />

                            {/* channels list */}
                            {/* <Chanels
                                channels={channels}
                                openCreateChannel={openCreateChannelModal}
                                selectedChannelChat={selectedChat.channelId}
                                onSelectChat={onSelectChat}
                            />
                            <h5 className="text-center mb-2">
                                <Link
                                    to="#"
                                    className="mb-3 px-4 mt-4 font-size-11 text-primary"
                                    onClick={() =>
                                        onChangeTab(CHATS_TABS.ARCHIVE)
                                    }
                                >
                                    Archived Contacts{' '}
                                    <i className="bx bxs-archive-in align-middle" />
                                </Link>
                            </h5> */}
                        </>
                    )}
                    {/* {active === CHATS_TABS.ARCHIVE && (
                        <>
                            <Archive
                                archiveContacts={archiveContacts}
                                selectedChat={selectedChat}
                                onSelectChat={onSelectChat}
                            />
                            <h5 className="text-center mb-2">
                                <Link
                                    to="#"
                                    className="mb-3 px-4 mt-4 font-size-11 text-primary"
                                    onClick={() =>
                                        onChangeTab(CHATS_TABS.DEFAULT)
                                    }
                                >
                                    Chats{' '}
                                    <i className="bx bxs-archive-out align-middle" />
                                </Link>
                            </h5>
                        </>
                    )} */}

                    {/* End chat-message-list */}
                </AppSimpleBar>
            </div>
            {/* add group Modal */}
            {/* {isOpenCreateChannel && (
                <AddGroupModal
                    isOpen={isOpenCreateChannel}
                    onClose={closeCreateChannelModal}
                    onCreateChannel={onCreateChannel}
                />
            )} */}

            {/* add contact modal */}
            {/* {isOpen && (
                <CreateContactModal
                    isOpen={isOpen}
                    onClose={closeModal}
                    onCreate={onCreateContact}
                />
            )} */}

            {/* {isOpenAddContact && (
                <ContactModal
                    isOpen={isOpenAddContact}
                    onClose={closeAddContactModal}
                    onAddContact={onAddContact}
                />
            )} */}
        </>
    );
};

export default Index;
